<template>
  <div class="bg-white p-3">
    <div class="header">
      <span class="header-icon">
        <i class="fas fa-layer-group"></i>
      </span>
      <h2>{{ $t('actionGroup.pageTitle') }}</h2>
      <span class="ml-3 refresh-icon" title="Atualizar Lista">
        <font-awesome-icon :icon="['fas', 'sync-alt']" @click="updatePage" />
      </span>
    </div>
    <div class="search-actions col-3 my-3 p-0">
      <input
        type="text"
        class="form-control"
        :placeholder="$t('actionGroup.searchInput')"
        v-model="filter"
        @keyup="getActionGroups"
      />
      <button class="btn btn-outline-primary">
        {{ $t('actionGroup.searchButton') }}
      </button>
    </div>
    <div>
      <b-table
        striped
        :items="actionGroups.groups"
        :fields="fields"
        :busy="loading"
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </template>
        <!-- <template v-slot:cell(active)="row">
          <div>
            <b-form-checkbox
              v-model="row.item.active"
              name="check-button"
              @change="handleActive(row.item)"
              switch
            ></b-form-checkbox>
          </div>
        </template> -->
        <template v-slot:cell(favourite)="row">
          <div>
            <span
              :class="!row.item.favourite ? 'star' : 'favorite'"
              @click="handleFavorite(row.item)"
            >
              <i class="fas fa-star"></i>
            </span>
          </div>
        </template>
        <template v-slot:cell(details)="row">
          <router-link :to="`/action-list/?groupId=${row.item._id}`">
            <span title="Detalhes" class="action-group-details">
              <font-awesome-icon :icon="['fas', 'search']" />
            </span>
          </router-link>
        </template>
        <template v-slot:cell(options)="row">
          <div class="text-primary">
            <span class="mx-2">
              <button
                v-b-modal="`modal-edit-action-group-${row.item._id}`"
                class="btn btn-outline-primary"
                title="Editar"
              >
                <font-awesome-icon :icon="['fas', 'pen']" />
                <ModalActionGroup
                  :groupData="row.item"
                  :updateActionGroupTable="getActionGroups"
                />
              </button>
              <button
                class="btn btn-outline-danger"
                title="Deletar"
                @click="handleDelete(row.item.name, row.item._id)"
              >
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
            </span>
          </div>
        </template>
      </b-table>
    </div>
    <div class="action-group-footer">
      <div class="pagination-area-answers">
        <paginate
          v-model="page"
          :pageCount="Math.ceil(actionGroups.total / 10)"
          :clickHandler="handlePaginate"
          :prevText="'‹'"
          :nextText="'›'"
          :activeClass="'active'"
          :containerClass="'pagination b-pagination'"
          :pageClass="'page-item'"
        ></paginate>
      </div>
      <div>
        <button class="btn btn-outline-primary" v-b-modal="'modal-new-group'">
          {{ $t('actionGroup.newGroupButton') }}
        </button>
        <ModalActionGroup :updateActionGroupTable="getActionGroups" />
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import Paginate from 'vuejs-paginate';
import { mapFields } from 'vuex-map-fields';
import api from '@/services/api';
import { mapActions } from 'vuex';
import ModalActionGroup from './Modal-Action-Group';

export default {
  components: {
    ModalActionGroup,
    Paginate,
  },

  data: () => ({
    userAuth: null,
    loading: true,
    actionGroups: [],
    page: 1,
    limit: 10,
    filter: null,
    fields: [],
  }),

  computed: {
    ...mapFields('actions', ['actionGroupData']),
    ...mapFields('companies', ['myMetric']),
  },

  methods: {
    ...mapActions('actions', ['getAllActionGroups', 'getAllActions']),

    async updatePage() {
      this.page = 1;
      this.filter = null;

      await this.getActionGroups();
    },

    async getActionGroups() {
      const response = await api.get(
        `action-groups/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            page: this.page,
            limit: this.limit,
            filter: this.filter ? this.filter : null,
          },
        },
      );

      this.actionGroups = response.data;

      this.loading = false;
    },

    handlePaginate() {
      this.loading = true;

      this.getActionGroups();
    },

    // handleActive(group) {
    //   swal({
    //     title: 'Tem certeza?',
    //     text: `Deseja ${group.active ? 'detativar' : 'ativar'} o grupo ${
    //       group.name
    //     }?`,
    //     icon: 'warning',
    //     buttons: true,
    //     dangerMode: true,
    //   }).then(async (willDelete) => {
    //     if (willDelete) {
    //       const actionText = group.active ? 'ativado' : 'desativado';

    //       await api.put(
    //         `${process.env.API_ROOT}/action-group/${this.userAuth.companyId}/${group._id}`,
    //         { active: group.active },
    //         { headers: { 'x-access-token': this.userAuth.token } },
    //       );

    //       swal({
    //         icon: 'success',
    //         title: `Grupo ${actionText}!`,
    //         text: `O grupo ${group.name} foi ${actionText}.`,
    //       });
    //     }
    //   });
    // },

    handleFavorite(data) {
      swal({
        title: this.$t('actionGroup.messages.favorite.title'),
        text: data.favourite
          ? `${this.$t('actionGroup.messages.favorite.description1')}
            ${data.name}`
          : `${this.$t('actionGroup.messages.favorite.description2')}
            ${data.name}`,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.patch(
            `${process.env.API_ROOT}/favourite-group/${this.userAuth.companyId}/${data._id}`,
            { favourite: !data.favourite },
            { headers: { 'x-access-token': this.userAuth.token } },
          );

          swal({
            icon: 'success',
            title: data.favourite
              ? `${data.name} -
                ${this.$t('actionGroup.messages.favoriteOk.title1')}`
              : `${data.name} -
                ${this.$t('actionGroup.messages.favoriteOk.title2')}`,
            text: data.favourite
              ? `${data.name} -
                ${this.$t('actionGroup.messages.favorite.description1')}`
              : `${data.name} -
                ${this.$t('actionGroup.messages.favorite.description2')}`,
          });

          if (!data.favourite) {
            this.actionGroupData._id = data._id;
            this.actionGroupData.name = data.name;
            this.myMetric = data.metric;
          }

          await this.getActionGroups();

          await this.getAllActions({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
            params: {
              type: this.myMetric,
              groupId: this.actionGroupData._id,
            },
          });
        }
      });
    },

    handleDelete(name, id) {
      swal({
        title: this.$t('actionGroup.messages.deleted.title'),
        text: `${this.$t('actionGroup.messages.deleted.description')} ${name}?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          this.loading = true;

          await api.delete(
            `${process.env.API_ROOT}/action-group/${this.userAuth.companyId}/${id}`,
            { headers: { 'x-access-token': this.userAuth.token } },
          );

          swal({
            icon: 'success',
            title: this.$t('actionGroup.messages.deletedOk.title'),
            text: ` ${name} -
              ${this.$t('actionGroup.messages.deletedOk.description')}`,
          });

          await this.getAllActionGroups({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
            params: {
              menuAside: false,
            },
          });

          await this.getActionGroups();
        }
      });
    },
  },

  async created() {
    this.fields = [
      { key: 'controlId', label: this.$t('actionGroup.groupTable.labels.id') },
      { key: 'name', label: this.$t('actionGroup.groupTable.labels.name') },
      { key: 'metric', label: this.$t('actionGroup.groupTable.labels.metric') },
      {
        key: 'favourite',
        label: this.$t('actionGroup.groupTable.labels.favourite'),
      },
      {
        key: 'details',
        label: this.$t('actionGroup.groupTable.labels.actions'),
      },
      {
        key: 'options',
        label: this.$t('actionGroup.groupTable.labels.options'),
      },
    ];

    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.getActionGroups();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.star,
.favorite {
  font-size: 25px;
}
.star {
  color: #d9d6d5;
}

.favorite {
  color: #ffc107;
}

.star:hover,
.favorite:hover {
  color: #ffc107;
  cursor: pointer;
}

.header {
  display: flex;
  flex-direction: row;

  .header-icon {
    float: left;
    font-size: 20px;
    padding-right: 12px;
    color: $gray;
  }

  .refresh-icon {
    margin-top: 1px;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: green;
    }
  }
}

h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.search-actions {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.pagination-area-answers >>> a {
  position: relative;
  display: block;
  padding: 10px;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
  outline: none;
}

.pagination-area-answers >>> .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background: #4ce595;
  border-color: #4ce595;
  outline: none;
}

.pagination-area-answers a {
  outline: none;
}

.action-group-details {
  font-size: 20px;
}

.action-group-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/action-group/index.vue